import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import http from "../api/http"
import 'dayjs/locale/zh-cn';
import locale from 'element-plus/es/locale/lang/zh-cn';

const app = createApp(App);
app.provide("http", http);
app.config.warnHandler = () => null;

app.use(store).use(router).use(ElementPlus,{locale}).mount('#app')
